import { Link } from 'react-router-dom'
import { Plus, Trophy, Calendar, TrendingUp } from 'lucide-react'

function DashboardPage() {
  // Mock data - replace with actual API calls
  const recentGames = [
    {
      id: '1',
      countryName: 'Freedonia',
      turn: 15,
      approval: 68,
      status: 'active',
      lastPlayed: '2 hours ago'
    },
    {
      id: '2', 
      countryName: 'Atlantica',
      turn: 8,
      approval: 45,
      status: 'active',
      lastPlayed: '1 day ago'
    }
  ]

  const stats = {
    totalGames: 12,
    activeGames: 2,
    bestApproval: 89,
    averageTurns: 22
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Dashboard</h1>
          <p className="text-gray-600 mt-2">Manage your government simulations</p>
        </div>
        <Link to="/game/new" className="btn btn-primary flex items-center space-x-2">
          <Plus className="w-5 h-5" />
          <span>New Game</span>
        </Link>
      </div>

      {/* Stats Overview */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
        <div className="stat-card">
          <div>
            <p className="text-sm font-medium text-gray-500">Total Games</p>
            <p className="text-2xl font-bold text-gray-900">{stats.totalGames}</p>
          </div>
          <Trophy className="w-8 h-8 text-primary-600" />
        </div>
        
        <div className="stat-card">
          <div>
            <p className="text-sm font-medium text-gray-500">Active Games</p>
            <p className="text-2xl font-bold text-gray-900">{stats.activeGames}</p>
          </div>
          <Calendar className="w-8 h-8 text-success-600" />
        </div>
        
        <div className="stat-card">
          <div>
            <p className="text-sm font-medium text-gray-500">Best Approval</p>
            <p className="text-2xl font-bold text-gray-900">{stats.bestApproval}%</p>
          </div>
          <TrendingUp className="w-8 h-8 text-warning-600" />
        </div>
        
        <div className="stat-card">
          <div>
            <p className="text-sm font-medium text-gray-500">Avg. Turns</p>
            <p className="text-2xl font-bold text-gray-900">{stats.averageTurns}</p>
          </div>
          <Trophy className="w-8 h-8 text-danger-600" />
        </div>
      </div>

      {/* Recent Games */}
      <div className="card">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-semibold text-gray-900">Recent Games</h2>
          <Link to="/games" className="text-primary-600 hover:text-primary-700 font-medium">
            View All
          </Link>
        </div>

        {recentGames.length > 0 ? (
          <div className="space-y-4">
            {recentGames.map((game) => (
              <div key={game.id} className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition-colors">
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <div className="flex items-center space-x-4">
                      <h3 className="font-semibold text-gray-900">{game.countryName}</h3>
                      <span className="badge badge-blue">Turn {game.turn}</span>
                      <span className={`badge ${
                        game.approval >= 60 ? 'badge-green' : 
                        game.approval >= 40 ? 'badge-yellow' : 'badge-red'
                      }`}>
                        {game.approval}% Approval
                      </span>
                    </div>
                    <p className="text-sm text-gray-500 mt-1">Last played: {game.lastPlayed}</p>
                  </div>
                  <Link 
                    to={`/game/${game.id}`}
                    className="btn btn-secondary"
                  >
                    Continue
                  </Link>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-12">
            <Trophy className="w-12 h-12 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">No games yet</h3>
            <p className="text-gray-500 mb-4">Start your first government simulation</p>
            <Link to="/game/new" className="btn btn-primary">
              Create New Game
            </Link>
          </div>
        )}
      </div>
    </div>
  )
}

export default DashboardPage